import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Spinner, Text, useToast } from "@chakra-ui/react";
import DealEditor from "./DealEditor";
import Navbar from "./Navbar";

const DealEditorPage = () => {

  const { productCode, dealId } = useParams();
  const [deal, setDeal] = useState(null);
  const [product, setProduct] = useState(null);
  const [dealLoaded, setDealLoaded] = useState(false);
  const [productLoaded, setProductLoaded] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDeal = async () => {
      try {
        const res = await fetch(
          `https://poc.mrc.ai/xol/api/deals/${dealId}`
        );
        const data = await res.json();
        setDeal(data);
      } catch {
        toast({ title: "Failed to load deal", status: "error" });
      } finally {
        setDealLoaded(true);
      }
    };

    const fetchProduct = async () => {
      try {
        const res = await fetch(
          `https://poc.mrc.ai/${productCode}/api/product`
        );
        const data = await res.json();
        setProduct(data[0]);
      } catch {
        toast({ title: "Failed to load product", status: "error" });
      } finally {
        setProductLoaded(true);
      }
    };

    fetchDeal();
    fetchProduct();
  }, [productCode, dealId]);

  if (!dealLoaded || !productLoaded) return <Spinner size="xl" />;

  return (
    <Box position="relative" width="100%" minHeight="100vh">
      <Navbar />

        <DealEditor
          productCode={productCode}
          deal={deal}
          productInstance={product}
          productTemplate={null}
        />

    </Box>
  );
};

export default DealEditorPage;
